import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap'
import { Link, useParams, useHistory ,withRouter} from 'react-router-dom'
import axios from 'axios'
import { useDispatch, sendFlashMessage } from '@/shared/components/flash'
import ApiErrorMessage from '@/shared/components/ApiErrorMessage'
import { connect } from 'react-redux'

const ViewBannerStatusPage = ({ organization }) => {
    const { id } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(true)
    const [banner, setBanner] = useState(null)

    useEffect(() => {
        axios
            .get(`/organization/${organization.id}/system/banner-status/${id}`)
            .then(res => {
                setBanner(res.data.data)
                setLoading(false)
            })
            .catch(err => {
                dispatch(
                    sendFlashMessage(
                        <ApiErrorMessage errors={err.response?.data} />,
                        'alert-danger'
                    )
                )
                setLoading(false)
            })
    }, [id, organization.id])

    if (loading) return <p>Loading...</p>

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Banner Status</h3>
                    <h3 className="page-subhead subhead">
                        <Link to="/">Home</Link> /{' '}
                        <Link to="/banner-status">Banner Status</Link> / View
                    </h3>
                </Col>
            </Row>

            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <Row className="mb-3">
                                <Col md="3"><strong>Domain Name</strong></Col>
                                <Col md="9">
                                    {banner.domain_name || `Domain #${banner.domain_id}`}
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md="3"><strong>Banner Text</strong></Col>
                                <Col md="9">
                                    <div
                                        className="wysiwyg-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: banner.banner_status
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md="3"><strong>Created At</strong></Col>
                                <Col md="9">
                                    {new Date(banner.created_at).toLocaleString()}
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12} className="text-right">
                                    <Button color="primary" outline onClick={() => history.goBack()}>
                                        Back
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default withRouter(
    connect(state => ({
        organization: state.organization
    }))(ViewBannerStatusPage)
);